import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon, PlusIcon } from '@heroicons/react/20/solid';
import { Button } from './Button';

export type DespatchUnit = 'product' | 'sku';

interface DespatchSplitButtonProps {
  disabled?: boolean;
  title?: string;
  productCount: number;
  skuUnitLabel: string;
  showMenu: boolean;
  onDespatch: (unit: DespatchUnit) => void;
}

const chevronClasses =
  'inline-flex items-center justify-center rounded-lg rounded-l-none border border-l-0 border-primary bg-transparent px-1.5 -ml-px text-primary transition-colors delay-50 font-inter hover:enabled:bg-blue-50 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300 disabled:text-gray-500';

const menuItemClasses =
  'group flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm text-gray-700 data-[focus]:bg-primary data-[focus]:text-white';

const menuCountClasses = 'text-xs text-gray-500 group-data-[focus]:text-white';

export function DespatchSplitButton({
  disabled,
  title,
  productCount,
  skuUnitLabel,
  showMenu,
  onDespatch,
}: DespatchSplitButtonProps) {
  if (!showMenu) {
    return (
      <Button
        label='Despatch'
        intent='secondary'
        size='xs'
        startIcon={<PlusIcon className='h-3 w-3' />}
        disabled={disabled}
        title={title}
        onClick={() => onDespatch('product')}
      />
    );
  }

  return (
    <div className='inline-flex items-stretch'>
      <Button
        label='Despatch'
        intent='secondary'
        size='xs'
        startIcon={<PlusIcon className='h-3 w-3' />}
        disabled={disabled}
        title={title}
        onClick={() => onDespatch('product')}
        className='rounded-r-none'
      />
      <Menu as='div' className='inline-flex'>
        <MenuButton
          disabled={disabled}
          title={title}
          aria-label='Despatch options'
          className={chevronClasses}
        >
          <ChevronDownIcon className='h-4 w-4' aria-hidden='true' />
        </MenuButton>
        <MenuItems
          anchor='bottom end'
          modal={false}
          transition
          className='z-[1200] w-64 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 [--anchor-gap:4px] transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[enter]:ease-out data-[leave]:duration-75 data-[leave]:ease-in'
        >
          <MenuItem>
            <button
              type='button'
              onClick={() => onDespatch('product')}
              className={menuItemClasses}
            >
              <span>Despatch product</span>
              <span className={menuCountClasses}>
                {productCount.toLocaleString()} products
              </span>
            </button>
          </MenuItem>
          <MenuItem>
            <button
              type='button'
              onClick={() => onDespatch('sku')}
              className={menuItemClasses}
            >
              <span>Despatch by SKU</span>
              <span className={menuCountClasses}>{skuUnitLabel}</span>
            </button>
          </MenuItem>
        </MenuItems>
      </Menu>
    </div>
  );
}
